export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID
  }
}

export const loginRequest = {
  scopes: ['User.Read']
}

// The request for the sign-in and token popups. Without a prompt Entra signs in whichever account it
// already has a session for — the cached account's login_hint, or the browser's only live Microsoft
// session — and never asks: signed into Microsoft as somebody else (a shared PC, a service account
// such as Power BI's) the person gets that identity, the platform answers 401 and the Login page cannot
// move on (#1426). select_account shows the account picker instead, every time. Never for the silent
// request: the hidden Entra iframe rejects any prompt other than none.
export const interactiveLoginRequest = { ...loginRequest, prompt: 'select_account' }
